import { Validator } from './types';

export const requiredValidator: Validator = {
  testIsValid: inputVal => inputVal !== null && inputVal !== undefined && inputVal !== '',
  errorMsg: () => 'Required field',
};
